import styled from 'styled-components';

export const DropdownContainer = styled.div<{
  focused?: boolean;
  size?: 'small' | 'default';
  $editIconOutside?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  border-radius: 10px;
  background: var(--grey-lighter);
  height: ${({ size }) => (size === 'small' ? '36px' : '46px')};
  padding: ${({ size }) => (size === 'small' ? '8px 10px' : '12px 10px')};

  ${({ focused }) =>
    focused &&
    `
      border: 1px solid var(--lilac);
      mix-blend-mode: multiply;
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
    `}

  ${({ $editIconOutside }) =>
    $editIconOutside &&
    `
      position: relative;

      svg {
        position: absolute;
        left: -45px;
        top: 50%;
        transform: translateY(-50%);
      }
    `}
`;

export const InputSelectMultipleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 250px;
`;
